/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-08-14",
    versionChannel: "nightly",
    buildDate: "2023-08-14T00:19:51.507Z",
    commitHash: "56b97e7b40ea40061d0844ac4d691d0e07ac4c05",
};
